import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
import createLogger from "vuex/dist/logger";
import indexMutation from "@/store/mutations/indexMutation";
import indexAction from "./actions/indexAction";
import indexGetters from "@/store/getters/indexGetter";
import settingModule from "@/store/modules/settingDataModule";
import cookieModule from "@/store/modules/cookieDataModule";
import gxUserInfoModule from "@/store/modules/gxUserInfoModule";
import insUserInfoModule from "@/store/modules/insUserInfoModule";
import insUserMediaModule from "@/store/modules/insUserMediaModule";
import userStatusModule from "@/store/modules/userStatusModule";
import paymentModule from "./modules/paymentModule";
import initialSettingModule from "@/store/modules/initialSettingModule";
import routerModule from "@/store/modules/routerModule";
import earcCoinsModule from "@/store/modules/earnCoinsModule";
import dialogModule from "@/store/modules/dialogModule";
import cionModule from "@/store/modules/cionModule";
import casinoModule from "@/store/modules/casinoModule";
import superPayModule from "@/store/modules/superPayModule";
import backUpAppModule from "@/store/modules/backUpAppModule";
import startUpPolicyModule from "@/store/modules/startUpPolicyModule";

const persistPaths: string[] = [
  "userList",
  "masterUserId",
  "currentPostId",
  "currentViewId",
  "currentUserId",
  "deviceId",
  "cookieModule",
  "gxUserInfoModule",
  "paymentModule",
  "userStatusModule",
  "insUserInfoModule",
  "insUserMediaModule",
  "cionModule",
  "superPayModule",
  "backUpAppModule",
  "startUpPolicyModule"
];

const vuexPlugins = [
  createPersistedState({
    paths: persistPaths
  })
];

if (
  process.env.NODE_ENV !== "production" ||
  process.env.VUE_APP_VUEX_LOGGER === "ON"
) {
  vuexPlugins.push(
    createLogger({
      collapsed: true // vuex logger
    })
  );
}

export default new Vuex.Store({
  modules: {
    dialogModule,
    settingModule,
    cookieModule,
    paymentModule,
    routerModule,
    earcCoinsModule,
    gxUserInfoModule,
    userStatusModule,
    insUserInfoModule,
    insUserMediaModule,
    initialSettingModule,
    cionModule,
    casinoModule,
    superPayModule,
    backUpAppModule,
    startUpPolicyModule
  },
  state: {
    currentUserId: null, //当前INS账号的ID
    currentPostId: null, //当前INS Post类型的ID
    currentViewId: null, //当前INS View类型的ID
    masterUserId: null, //主账号的ID
    deviceId: null, //设备的ID
    userList: [], //用户列表
    misc: {} // 杂项
  },
  mutations: indexMutation,
  actions: indexAction,
  getters: indexGetters,
  plugins: vuexPlugins,
  strict: process.env.NODE_ENV !== "production"
});
